<div class="calculator__left">
  <div class="city-input">
    <div class="calculator__left-title">Расчет стоимости перевозки</div>
    
    <el-form-item prop="sender.cityFrom" class="calculator__input calculator__input-from">
      <el-select
        v-model="dataForm.sender.cityFrom"
        placeholder="Выбрать"
        filterable
        v-cancel-read-only
        :autocomplete=randomAutocomplete()
        @change="hanlerCityFrom"
        class="city_to"
      >
        <el-option
          v-for="(city, index) in citiesFrom"
          :key="index"
          :label="city.name"
          :value="city.name"
          :disabled="dataForm.consignee.cityTo == city.name || city.name.includes('(Москва)')"
        />
      </el-select>
    </el-form-item>
    <div class="total-weight--error total-weight--error_prefix_icon" v-show="checkCityRoadFrom()">
      <div class="warning-icon">i</div>
      Внимание: выдача/прием груза в {{dataForm.sender.cityFrom}} осуществляется на трассе. В населенный пункт авто не заезжает!
    </div>
  </div>
  <div>
    <el-radio-group v-model="dataForm.applicationCargoPickup.isCargoPickup" size="large" class="calculator__location__btns" :disabled="cargoPickupSwitchFrom()">
      <el-radio-button :label="false">Сдать на склад</el-radio-button>
      <el-radio-button :label="true">Забор груза</el-radio-button>
    </el-radio-group>
  </div>
  <div class="city-input city-input_type_storage">
    <el-form-item prop="sender.officeFrom" class="calculator__input" v-if="officeFromShow()">
      <el-select
        v-model="dataForm.sender.officeFrom"
        placeholder="Выберите склад"
        filterable
        v-cancel-read-only
        :autocomplete=randomAutocomplete()
        class="city_from"
        :disabled="(dataForm.sender.cityFrom == '')"
        value-key='id'
      >
        <el-option
          v-for="(office, index) in officesFrom"
          :key="index"
          :label="office.address"
          :value="office"
        />
      </el-select>
    </el-form-item>
    <div class="total-weight--error total-weight--error_prefix_icon" v-show="checkStorageFrom()">
      <div class="warning-icon">i</div>
      Допустимые габариты склада превышены - выберите другой склад
    </div>
    <div class="total-weight--error total-weight--error_prefix_icon" v-show="(dataForm.sender.cityFrom != '') && !dataForm.sender.officeFrom && !dataForm.applicationCargoPickup.isCargoPickup">
      <div class="warning-icon">i</div>
      Выберите склад для грузов
    </div>
  </div>
  <div class="city-input">
    <el-form-item prop="consignee.cityTo" class="calculator__input calculator__input-to">
      <el-select
        v-model="dataForm.consignee.cityTo"
        placeholder="Выбрать"
        filterable
        v-cancel-read-only
        @change="hanlerCityTo"
        autocomplete="do-not-autofill"
        class="city_from"
      >
        <el-option
          v-for="(city, index) in citiesTo"
          :key="index"
          :label="city.name"
          :value="city.name"
          :disabled="dataForm.sender.cityFrom == city.name"
        />
      </el-select>
    </el-form-item>
    <div class="total-weight--error total-weight--error_prefix_icon" v-show="checkCityRoadTo()">
      <div class="warning-icon">i</div>
      Внимание: выдача/прием груза в  {{dataForm.consignee.cityTo}} осуществляется на трассе. В населенный пункт авто не заезжает!
    </div>
  </div>
  <div>
    <el-radio-group v-model="dataForm.applicationCargoPickup.deliveryToTheAddress" size="large" class="calculator__location__btns" :disabled="cargoPickupSwitchTo()">
      <el-radio-button :label="false">Забрать на складе</el-radio-button>
      <el-radio-button :label="true">Доставка до адреса</el-radio-button>
    </el-radio-group>
  </div>
  <div class="city-input city-input_type_storage">
    <el-form-item class="calculator__input" prop="consignee.officeTo" v-if="officeToShow()">
      <el-select
        v-model="dataForm.consignee.officeTo"
        placeholder="Выберите склад"
        filterable
        v-cancel-read-only
        autocomplete="do-not-autofill"
        class="city_from"
        :disabled="(dataForm.consignee.cityTo == '')"
        value-key='id'
      >
        <el-option
          v-for="(office, index) in officesTo"
          :key="index"
          :label="office.address"
          :value="officesTo[index]"
        />
      </el-select>
    </el-form-item>
    <div class="total-weight--error total-weight--error_prefix_icon" v-show="checkStorageTo()">
      <div class="warning-icon">i</div>
      Допустимые габариты склада превышены - выберите другой склад
    </div>
    <div class="total-weight--error total-weight--error_prefix_icon" v-show="(dataForm.consignee.cityTo != '') && !dataForm.consignee.officeTo && !dataForm.applicationCargoPickup.deliveryToTheAddress">
      <div class="warning-icon">i</div>
      Выберите склад для грузов
    </div>
  </div>
  <div v-if="isMoscowCity" class="order-creation-form__fields error-message-banner moscow-message">
      <div class="error-message-banner__text">
          <div class="error-message-banner__title">Доставка до склада WILDBERRIES.</div>
          <div class="error-message-banner__description">Привезем груз на склад маркетплейса в {{ dataForm.consignee.cityTo }}. Ограничение на одно место: 50-300 кг, 120х80х120 см</div>
      </div>
  </div>
  <div class="calculator__left__bottom">
      <div class="calculator__left__bottom-item" name="declared_value"><span class="sum" data-min="1" data-max="0" data-delay="5" data-increment="10">{{(dataFormApi.sumText != "Загрузка...") ? dataFormApi.currencyCount(dataFormApi.sumText) + ((dataFormApi.currencyCountry == "ru") ? " руб" : " тенге") : dataFormApi.sumText}}</span></div>
  </div>
  <div>
    <el-radio-group v-model="dataFormApi.currencyCountry" size="large" class="calculator__location__btns-cost">
      <el-radio-button label="ru">RUB</el-radio-button>
      <el-radio-button label="kz">KZT</el-radio-button>
    </el-radio-group>
  </div>
  <div class="calculator__reviews-buttons">
    <a class="link_good" id="btnGoodPrice">Отличная цена</a>
  </div>
  <div class="container_button">
    <el-form-item>
      <!-- <router-link to="/calculator" class="button-link">
        <el-button 
          class="button_shadow"
          type="primary"
        > 
          Калькулятор
        </el-button>
      </router-link> -->
    </el-form-item>
    <el-form-item>
      <!-- <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-next')"
        >
        Далее
      </el-button> -->
    </el-form-item>
  </div>
</div>
<div class="calculator__center-line"></div>